import { Component, OnDestroy, OnInit } from "@angular/core"
import { ActivatedRoute, Router } from "@angular/router"
import { Subscription } from "rxjs"
import { BrowsingService } from "../../../services/browsing.service"
import { FacetingService } from "../../../services/faceting.service"

@Component({
    selector: "app-filter-by-type",
    templateUrl: "./filter-by-type.component.html",
    styleUrls: ["./filter-by-type.component.scss"],
})
export class FilterByTypeComponent implements OnInit, OnDestroy {
    public mediaTypes: string[] = []
    public selectedType: string = null
    private subscriptions: Subscription[] = []

    constructor(
        private browsingService: BrowsingService,
        private route: ActivatedRoute,
        private facetingService: FacetingService
    ) {}

    public ngOnInit() {
        this.mediaTypes = this.browsingService.mediaTypes
        this.subscriptions.push(
            this.route.queryParams.subscribe(() => {
                const facets = this.facetingService.getSelectedFacets(this.route)
                this.selectedType = null
                facets.map((facet) => {
                    if (facet.indexOf("media_type") !== -1) {
                        this.selectedType = facet.split(":")[1]
                    }
                })
            })
        )
    }

    public changeType($event, type: string) {
        this.facetingService.addFilter(`media_type:${type}`, this.route, true)
    }

    public ngOnDestroy() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }
}
